import { ROW_COL_SPAN } from '@modules/dashboard/constants';
import { getNewCellID, getNewRowID } from '@modules/dashboard/helpers';
import {
  DashboardCell,
  DashboardLayout,
  DashboardRow,
  DashboardViewFragment,
} from 'generated/graphql';

export function generateMetadataV2(widgets: DashboardViewFragment['widgets']) {
  const layout: DashboardLayout = { rows: [] };

  if (!widgets?.length) {
    return { layout };
  }

  for (let index = 0, rowIndex = 0; index < widgets.length; index++) {
    if (!layout.rows[rowIndex]) {
      const row: DashboardRow = {
        id: getNewRowID(),
        cells: [],
        height: 0,
      };
      layout.rows[rowIndex] = row;
    }

    const widget = widgets[index];
    const cell: DashboardCell = {
      id: getNewCellID(),
      contentID: widget.id,
      columnSpan: 3,
    };

    layout.rows[rowIndex].cells.push(cell);

    if (layout.rows[rowIndex].cells.length === 2) {
      rowIndex++;
    }
  }

  layout.rows.forEach((row) => {
    row.cells.forEach((cell) => {
      cell.columnSpan = ROW_COL_SPAN / row.cells.length;
    });
  });

  return { layout };
}
